import { render } from "./Topup.vue?vue&type=template&id=40fafef6&scoped=true"
import script from "./Topup.vue?vue&type=script&lang=js"
export * from "./Topup.vue?vue&type=script&lang=js"

import "./Topup.vue?vue&type=style&index=0&id=40fafef6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40fafef6"]])

export default __exports__